import { ProxyRequestException__get_Response, ProxyRequestException__get_StatusCode, ProxyRequestException } from "./fable_modules/Fable.Remoting.Client.8.0.0/Types.fs.js";
import { ServerError_$reflection, ServerError } from "./Shared/Errors.jsx";
import { SimpleJson_tryParse } from "./fable_modules/Fable.SimpleJson.3.24.0/SimpleJson.fs.js";
import { Convert_fromJson } from "./fable_modules/Fable.SimpleJson.3.24.0/Json.Converter.fs.js";
import { createTypeInfo } from "./fable_modules/Fable.SimpleJson.3.24.0/TypeInfo.Converter.fs.js";
import { anonRecord_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { errorToast } from "./Toasts.jsx";
import { Remoting_buildProxy_64DC51C } from "./fable_modules/Fable.Remoting.Client.8.0.0/Remoting.fs.js";
import { RemotingModule_createApi, RemotingModule_withBaseUrl } from "./fable_modules/Fable.Remoting.Client.8.0.0/Remoting.fs.js";
import { IHomeApi_$reflection, IRuleApi_$reflection, IReportApi_$reflection, IS3Api_$reflection, INotificationApi_$reflection, ITrackLevelApi_$reflection, ITaskApi_$reflection, ITrackLevelCourseApi_$reflection, ITrackApi_$reflection, IEventApi_$reflection, IWorkplaceApi_$reflection, ITitleApi_$reflection, IRegionApi_$reflection, ICourseApi_$reflection, IAuditApi_$reflection, IUserApi_$reflection } from "./Shared/Api.jsx";

export function exnToError(ex) {
    let matchValue;
    if (ex instanceof ProxyRequestException) {
        const e = ex;
        try {
            return ((matchValue = SimpleJson_tryParse(ProxyRequestException__get_Response(e).ResponseBody), (matchValue != null) ? Convert_fromJson(matchValue, createTypeInfo(anonRecord_type(["error", ServerError_$reflection()]))) : (() => {
                throw new Error("Couldn\'t parse the input JSON string because it seems to be invalid");
            })())).error;
        }
        catch (_parseError) {
            return (ProxyRequestException__get_StatusCode(e) === 401) ? (new ServerError(2, [])) : (new ServerError(0, []));
        }
    }
    else {
        return new ServerError(0, []);
    }
}

export function toastServerError(setCtx, ex) {
    const _arg = exnToError(ex);
    switch (_arg.tag) {
        case 1: {
            errorToast(setCtx, "UnauthorizedError", "Feilmelding", "Du har ikke de nødvendige tilgangene for dette", undefined);
            break;
        }
        case 0: {
            errorToast(setCtx, "InternalError", "Noe gikk galt", "", undefined);
            break;
        }
        default:
            window.location.href = "/api/login";
    }
}

export const User = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), IUserApi_$reflection());

export const AuditLog = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), IAuditApi_$reflection());

export const Course = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), ICourseApi_$reflection());

export const Region = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), IRegionApi_$reflection());

export const Title = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), ITitleApi_$reflection());

export const Workplace = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), IWorkplaceApi_$reflection());

export const Event$ = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), IEventApi_$reflection());

export const Track = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), ITrackApi_$reflection());

export const TrackLevelCourse = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), ITrackLevelCourseApi_$reflection());

export const Task = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), ITaskApi_$reflection());

export const TrackLevel = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), ITrackLevelApi_$reflection());

export const Notification = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), INotificationApi_$reflection());

export const S3 = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), IS3Api_$reflection());

export const Report = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), IReportApi_$reflection());

export const Rule = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), IRuleApi_$reflection());

export const Home = Remoting_buildProxy_64DC51C(RemotingModule_withBaseUrl("/api", RemotingModule_createApi()), IHomeApi_$reflection());

//# sourceMappingURL=ApiClient.jsx.map
